/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ConsoleRouteImport } from './routes/_console'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as ConsoleIndexRouteImport } from './routes/_console.index'
import { Route as ConsoleAuditingRouteImport } from './routes/_console.auditing'
import { Route as ConsoleDevicesRouteImport } from './routes/_console.devices'
import { Route as ConsoleFederationRouteImport } from './routes/_console.federation'
import { Route as ConsolePersonalTokensRouteImport } from './routes/_console.personal-tokens'
import { Route as ConsoleRegistrationTokensRouteImport } from './routes/_console.registration-tokens'
import { Route as ConsoleRoomsRouteImport } from './routes/_console.rooms'
import { Route as ConsoleSupervisionRouteImport } from './routes/_console.supervision'
import { Route as ConsoleUsersRouteImport } from './routes/_console.users'
import { Route as ConsoleVerificationLabelsRouteImport } from './routes/_console.verification-labels'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth.login.index'
import { Route as ConsoleDevicesIndexRouteImport } from './routes/_console.devices.index'
import { Route as ConsoleDevicesApplicationsRouteImport } from './routes/_console.devices.applications'
import { Route as ConsoleDevicesLegacyRouteImport } from './routes/_console.devices.legacy'
import { Route as ConsoleDevicesUserRouteImport } from './routes/_console.devices.user'
import { Route as ConsoleFederationIndexRouteImport } from './routes/_console.federation.index'
import { Route as ConsoleFederationAllowedDomainsRouteImport } from './routes/_console.federation.allowed-domains'
import { Route as ConsoleFederationKnownDomainsRouteImport } from './routes/_console.federation.known-domains'
import { Route as ConsolePersonalTokensTokenIdRouteImport } from './routes/_console.personal-tokens.$tokenId'
import { Route as ConsoleRegistrationTokensTokenIdRouteImport } from './routes/_console.registration-tokens.$tokenId'
import { Route as ConsoleRoomsRoomIdRouteImport } from './routes/_console.rooms.$roomId'
import { Route as ConsoleUsersUserIdRouteImport } from './routes/_console.users.$userId'
import { Route as ConsoleDevicesApplicationsClientIdRouteImport } from './routes/_console.devices.applications.$clientId'
import { Route as ConsoleDevicesLegacySessionIdRouteImport } from './routes/_console.devices.legacy.$sessionId'
import { Route as ConsoleDevicesUserSessionIdRouteImport } from './routes/_console.devices.user.$sessionId'
import { Route as ConsoleFederationKnownDomainsDestinationRouteImport } from './routes/_console.federation.known-domains.$destination'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleRoute = ConsoleRouteImport.update({
  id: '/_console',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleAuditingRoute = ConsoleAuditingRouteImport.update({
  id: '/auditing',
  path: '/auditing',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleDevicesRoute = ConsoleDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleFederationRoute = ConsoleFederationRouteImport.update({
  id: '/federation',
  path: '/federation',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsolePersonalTokensRoute = ConsolePersonalTokensRouteImport.update({
  id: '/personal-tokens',
  path: '/personal-tokens',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleRegistrationTokensRoute =
  ConsoleRegistrationTokensRouteImport.update({
    id: '/registration-tokens',
    path: '/registration-tokens',
    getParentRoute: () => ConsoleRoute,
  } as any)
const ConsoleRoomsRoute = ConsoleRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleSupervisionRoute = ConsoleSupervisionRouteImport.update({
  id: '/supervision',
  path: '/supervision',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleUsersRoute = ConsoleUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleVerificationLabelsRoute =
  ConsoleVerificationLabelsRouteImport.update({
    id: '/verification-labels',
    path: '/verification-labels',
    getParentRoute: () => ConsoleRoute,
  } as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any)
const ConsoleDevicesIndexRoute = ConsoleDevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleDevicesRoute,
} as any)
const ConsoleDevicesApplicationsRoute =
  ConsoleDevicesApplicationsRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => ConsoleDevicesRoute,
  } as any)
const ConsoleDevicesLegacyRoute = ConsoleDevicesLegacyRouteImport.update({
  id: '/legacy',
  path: '/legacy',
  getParentRoute: () => ConsoleDevicesRoute,
} as any)
const ConsoleDevicesUserRoute = ConsoleDevicesUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => ConsoleDevicesRoute,
} as any)
const ConsoleFederationIndexRoute = ConsoleFederationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleFederationRoute,
} as any)
const ConsoleFederationAllowedDomainsRoute =
  ConsoleFederationAllowedDomainsRouteImport.update({
    id: '/allowed-domains',
    path: '/allowed-domains',
    getParentRoute: () => ConsoleFederationRoute,
  } as any)
const ConsoleFederationKnownDomainsRoute =
  ConsoleFederationKnownDomainsRouteImport.update({
    id: '/known-domains',
    path: '/known-domains',
    getParentRoute: () => ConsoleFederationRoute,
  } as any)
const ConsolePersonalTokensTokenIdRoute =
  ConsolePersonalTokensTokenIdRouteImport.update({
    id: '/$tokenId',
    path: '/$tokenId',
    getParentRoute: () => ConsolePersonalTokensRoute,
  } as any)
const ConsoleRegistrationTokensTokenIdRoute =
  ConsoleRegistrationTokensTokenIdRouteImport.update({
    id: '/$tokenId',
    path: '/$tokenId',
    getParentRoute: () => ConsoleRegistrationTokensRoute,
  } as any)
const ConsoleRoomsRoomIdRoute = ConsoleRoomsRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => ConsoleRoomsRoute,
} as any)
const ConsoleUsersUserIdRoute = ConsoleUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => ConsoleUsersRoute,
} as any)
const ConsoleDevicesApplicationsClientIdRoute =
  ConsoleDevicesApplicationsClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => ConsoleDevicesApplicationsRoute,
  } as any)
const ConsoleDevicesLegacySessionIdRoute =
  ConsoleDevicesLegacySessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => ConsoleDevicesLegacyRoute,
  } as any)
const ConsoleDevicesUserSessionIdRoute =
  ConsoleDevicesUserSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => ConsoleDevicesUserRoute,
  } as any)
const ConsoleFederationKnownDomainsDestinationRoute =
  ConsoleFederationKnownDomainsDestinationRouteImport.update({
    id: '/$destination',
    path: '/$destination',
    getParentRoute: () => ConsoleFederationKnownDomainsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ConsoleIndexRoute
  '/callback': typeof CallbackRoute
  '/auditing': typeof ConsoleAuditingRoute
  '/devices': typeof ConsoleDevicesRouteWithChildren
  '/federation': typeof ConsoleFederationRouteWithChildren
  '/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/rooms': typeof ConsoleRoomsRouteWithChildren
  '/supervision': typeof ConsoleSupervisionRoute
  '/users': typeof ConsoleUsersRouteWithChildren
  '/verification-labels': typeof ConsoleVerificationLabelsRoute
  '/devices/applications': typeof ConsoleDevicesApplicationsRouteWithChildren
  '/devices/legacy': typeof ConsoleDevicesLegacyRouteWithChildren
  '/devices/user': typeof ConsoleDevicesUserRouteWithChildren
  '/federation/allowed-domains': typeof ConsoleFederationAllowedDomainsRoute
  '/federation/known-domains': typeof ConsoleFederationKnownDomainsRouteWithChildren
  '/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/users/$userId': typeof ConsoleUsersUserIdRoute
  '/login/': typeof AuthLoginIndexRoute
  '/devices/': typeof ConsoleDevicesIndexRoute
  '/federation/': typeof ConsoleFederationIndexRoute
  '/devices/applications/$clientId': typeof ConsoleDevicesApplicationsClientIdRoute
  '/devices/legacy/$sessionId': typeof ConsoleDevicesLegacySessionIdRoute
  '/devices/user/$sessionId': typeof ConsoleDevicesUserSessionIdRoute
  '/federation/known-domains/$destination': typeof ConsoleFederationKnownDomainsDestinationRoute
}
export interface FileRoutesByTo {
  '/': typeof ConsoleIndexRoute
  '/callback': typeof CallbackRoute
  '/auditing': typeof ConsoleAuditingRoute
  '/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/rooms': typeof ConsoleRoomsRouteWithChildren
  '/supervision': typeof ConsoleSupervisionRoute
  '/users': typeof ConsoleUsersRouteWithChildren
  '/verification-labels': typeof ConsoleVerificationLabelsRoute
  '/devices/applications': typeof ConsoleDevicesApplicationsRouteWithChildren
  '/devices/legacy': typeof ConsoleDevicesLegacyRouteWithChildren
  '/devices/user': typeof ConsoleDevicesUserRouteWithChildren
  '/federation/allowed-domains': typeof ConsoleFederationAllowedDomainsRoute
  '/federation/known-domains': typeof ConsoleFederationKnownDomainsRouteWithChildren
  '/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/users/$userId': typeof ConsoleUsersUserIdRoute
  '/login': typeof AuthLoginIndexRoute
  '/devices': typeof ConsoleDevicesIndexRoute
  '/federation': typeof ConsoleFederationIndexRoute
  '/devices/applications/$clientId': typeof ConsoleDevicesApplicationsClientIdRoute
  '/devices/legacy/$sessionId': typeof ConsoleDevicesLegacySessionIdRoute
  '/devices/user/$sessionId': typeof ConsoleDevicesUserSessionIdRoute
  '/federation/known-domains/$destination': typeof ConsoleFederationKnownDomainsDestinationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_console': typeof ConsoleRouteWithChildren
  '/callback': typeof CallbackRoute
  '/_console/auditing': typeof ConsoleAuditingRoute
  '/_console/devices': typeof ConsoleDevicesRouteWithChildren
  '/_console/federation': typeof ConsoleFederationRouteWithChildren
  '/_console/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/_console/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/_console/rooms': typeof ConsoleRoomsRouteWithChildren
  '/_console/supervision': typeof ConsoleSupervisionRoute
  '/_console/users': typeof ConsoleUsersRouteWithChildren
  '/_console/verification-labels': typeof ConsoleVerificationLabelsRoute
  '/_console/': typeof ConsoleIndexRoute
  '/_console/devices/applications': typeof ConsoleDevicesApplicationsRouteWithChildren
  '/_console/devices/legacy': typeof ConsoleDevicesLegacyRouteWithChildren
  '/_console/devices/user': typeof ConsoleDevicesUserRouteWithChildren
  '/_console/federation/allowed-domains': typeof ConsoleFederationAllowedDomainsRoute
  '/_console/federation/known-domains': typeof ConsoleFederationKnownDomainsRouteWithChildren
  '/_console/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/_console/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/_console/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/_console/users/$userId': typeof ConsoleUsersUserIdRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_console/devices/': typeof ConsoleDevicesIndexRoute
  '/_console/federation/': typeof ConsoleFederationIndexRoute
  '/_console/devices/applications/$clientId': typeof ConsoleDevicesApplicationsClientIdRoute
  '/_console/devices/legacy/$sessionId': typeof ConsoleDevicesLegacySessionIdRoute
  '/_console/devices/user/$sessionId': typeof ConsoleDevicesUserSessionIdRoute
  '/_console/federation/known-domains/$destination': typeof ConsoleFederationKnownDomainsDestinationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/auditing'
    | '/devices'
    | '/federation'
    | '/personal-tokens'
    | '/registration-tokens'
    | '/rooms'
    | '/supervision'
    | '/users'
    | '/verification-labels'
    | '/devices/applications'
    | '/devices/legacy'
    | '/devices/user'
    | '/federation/allowed-domains'
    | '/federation/known-domains'
    | '/personal-tokens/$tokenId'
    | '/registration-tokens/$tokenId'
    | '/rooms/$roomId'
    | '/users/$userId'
    | '/login/'
    | '/devices/'
    | '/federation/'
    | '/devices/applications/$clientId'
    | '/devices/legacy/$sessionId'
    | '/devices/user/$sessionId'
    | '/federation/known-domains/$destination'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/auditing'
    | '/personal-tokens'
    | '/registration-tokens'
    | '/rooms'
    | '/supervision'
    | '/users'
    | '/verification-labels'
    | '/devices/applications'
    | '/devices/legacy'
    | '/devices/user'
    | '/federation/allowed-domains'
    | '/federation/known-domains'
    | '/personal-tokens/$tokenId'
    | '/registration-tokens/$tokenId'
    | '/rooms/$roomId'
    | '/users/$userId'
    | '/login'
    | '/devices'
    | '/federation'
    | '/devices/applications/$clientId'
    | '/devices/legacy/$sessionId'
    | '/devices/user/$sessionId'
    | '/federation/known-domains/$destination'
  id:
    | '__root__'
    | '/_auth'
    | '/_console'
    | '/callback'
    | '/_console/auditing'
    | '/_console/devices'
    | '/_console/federation'
    | '/_console/personal-tokens'
    | '/_console/registration-tokens'
    | '/_console/rooms'
    | '/_console/supervision'
    | '/_console/users'
    | '/_console/verification-labels'
    | '/_console/'
    | '/_console/devices/applications'
    | '/_console/devices/legacy'
    | '/_console/devices/user'
    | '/_console/federation/allowed-domains'
    | '/_console/federation/known-domains'
    | '/_console/personal-tokens/$tokenId'
    | '/_console/registration-tokens/$tokenId'
    | '/_console/rooms/$roomId'
    | '/_console/users/$userId'
    | '/_auth/login/'
    | '/_console/devices/'
    | '/_console/federation/'
    | '/_console/devices/applications/$clientId'
    | '/_console/devices/legacy/$sessionId'
    | '/_console/devices/user/$sessionId'
    | '/_console/federation/known-domains/$destination'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ConsoleRoute: typeof ConsoleRouteWithChildren
  CallbackRoute: typeof CallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console': {
      id: '/_console'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console/': {
      id: '/_console/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ConsoleIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/auditing': {
      id: '/_console/auditing'
      path: '/auditing'
      fullPath: '/auditing'
      preLoaderRoute: typeof ConsoleAuditingRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/devices': {
      id: '/_console/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof ConsoleDevicesRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/federation': {
      id: '/_console/federation'
      path: '/federation'
      fullPath: '/federation'
      preLoaderRoute: typeof ConsoleFederationRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/personal-tokens': {
      id: '/_console/personal-tokens'
      path: '/personal-tokens'
      fullPath: '/personal-tokens'
      preLoaderRoute: typeof ConsolePersonalTokensRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/registration-tokens': {
      id: '/_console/registration-tokens'
      path: '/registration-tokens'
      fullPath: '/registration-tokens'
      preLoaderRoute: typeof ConsoleRegistrationTokensRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/rooms': {
      id: '/_console/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof ConsoleRoomsRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/supervision': {
      id: '/_console/supervision'
      path: '/supervision'
      fullPath: '/supervision'
      preLoaderRoute: typeof ConsoleSupervisionRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/users': {
      id: '/_console/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ConsoleUsersRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/verification-labels': {
      id: '/_console/verification-labels'
      path: '/verification-labels'
      fullPath: '/verification-labels'
      preLoaderRoute: typeof ConsoleVerificationLabelsRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_console/devices/': {
      id: '/_console/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof ConsoleDevicesIndexRouteImport
      parentRoute: typeof ConsoleDevicesRoute
    }
    '/_console/devices/applications': {
      id: '/_console/devices/applications'
      path: '/applications'
      fullPath: '/devices/applications'
      preLoaderRoute: typeof ConsoleDevicesApplicationsRouteImport
      parentRoute: typeof ConsoleDevicesRoute
    }
    '/_console/devices/legacy': {
      id: '/_console/devices/legacy'
      path: '/legacy'
      fullPath: '/devices/legacy'
      preLoaderRoute: typeof ConsoleDevicesLegacyRouteImport
      parentRoute: typeof ConsoleDevicesRoute
    }
    '/_console/devices/user': {
      id: '/_console/devices/user'
      path: '/user'
      fullPath: '/devices/user'
      preLoaderRoute: typeof ConsoleDevicesUserRouteImport
      parentRoute: typeof ConsoleDevicesRoute
    }
    '/_console/federation/': {
      id: '/_console/federation/'
      path: '/'
      fullPath: '/federation/'
      preLoaderRoute: typeof ConsoleFederationIndexRouteImport
      parentRoute: typeof ConsoleFederationRoute
    }
    '/_console/federation/allowed-domains': {
      id: '/_console/federation/allowed-domains'
      path: '/allowed-domains'
      fullPath: '/federation/allowed-domains'
      preLoaderRoute: typeof ConsoleFederationAllowedDomainsRouteImport
      parentRoute: typeof ConsoleFederationRoute
    }
    '/_console/federation/known-domains': {
      id: '/_console/federation/known-domains'
      path: '/known-domains'
      fullPath: '/federation/known-domains'
      preLoaderRoute: typeof ConsoleFederationKnownDomainsRouteImport
      parentRoute: typeof ConsoleFederationRoute
    }
    '/_console/personal-tokens/$tokenId': {
      id: '/_console/personal-tokens/$tokenId'
      path: '/$tokenId'
      fullPath: '/personal-tokens/$tokenId'
      preLoaderRoute: typeof ConsolePersonalTokensTokenIdRouteImport
      parentRoute: typeof ConsolePersonalTokensRoute
    }
    '/_console/registration-tokens/$tokenId': {
      id: '/_console/registration-tokens/$tokenId'
      path: '/$tokenId'
      fullPath: '/registration-tokens/$tokenId'
      preLoaderRoute: typeof ConsoleRegistrationTokensTokenIdRouteImport
      parentRoute: typeof ConsoleRegistrationTokensRoute
    }
    '/_console/rooms/$roomId': {
      id: '/_console/rooms/$roomId'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof ConsoleRoomsRoomIdRouteImport
      parentRoute: typeof ConsoleRoomsRoute
    }
    '/_console/users/$userId': {
      id: '/_console/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof ConsoleUsersUserIdRouteImport
      parentRoute: typeof ConsoleUsersRoute
    }
    '/_console/devices/applications/$clientId': {
      id: '/_console/devices/applications/$clientId'
      path: '/$clientId'
      fullPath: '/devices/applications/$clientId'
      preLoaderRoute: typeof ConsoleDevicesApplicationsClientIdRouteImport
      parentRoute: typeof ConsoleDevicesApplicationsRoute
    }
    '/_console/devices/legacy/$sessionId': {
      id: '/_console/devices/legacy/$sessionId'
      path: '/$sessionId'
      fullPath: '/devices/legacy/$sessionId'
      preLoaderRoute: typeof ConsoleDevicesLegacySessionIdRouteImport
      parentRoute: typeof ConsoleDevicesLegacyRoute
    }
    '/_console/devices/user/$sessionId': {
      id: '/_console/devices/user/$sessionId'
      path: '/$sessionId'
      fullPath: '/devices/user/$sessionId'
      preLoaderRoute: typeof ConsoleDevicesUserSessionIdRouteImport
      parentRoute: typeof ConsoleDevicesUserRoute
    }
    '/_console/federation/known-domains/$destination': {
      id: '/_console/federation/known-domains/$destination'
      path: '/$destination'
      fullPath: '/federation/known-domains/$destination'
      preLoaderRoute: typeof ConsoleFederationKnownDomainsDestinationRouteImport
      parentRoute: typeof ConsoleFederationKnownDomainsRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginIndexRoute: AuthLoginIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ConsoleDevicesApplicationsRouteChildren {
  ConsoleDevicesApplicationsClientIdRoute: typeof ConsoleDevicesApplicationsClientIdRoute
}

const ConsoleDevicesApplicationsRouteChildren: ConsoleDevicesApplicationsRouteChildren =
  {
    ConsoleDevicesApplicationsClientIdRoute:
      ConsoleDevicesApplicationsClientIdRoute,
  }

const ConsoleDevicesApplicationsRouteWithChildren =
  ConsoleDevicesApplicationsRoute._addFileChildren(
    ConsoleDevicesApplicationsRouteChildren,
  )

interface ConsoleDevicesLegacyRouteChildren {
  ConsoleDevicesLegacySessionIdRoute: typeof ConsoleDevicesLegacySessionIdRoute
}

const ConsoleDevicesLegacyRouteChildren: ConsoleDevicesLegacyRouteChildren = {
  ConsoleDevicesLegacySessionIdRoute: ConsoleDevicesLegacySessionIdRoute,
}

const ConsoleDevicesLegacyRouteWithChildren =
  ConsoleDevicesLegacyRoute._addFileChildren(ConsoleDevicesLegacyRouteChildren)

interface ConsoleDevicesUserRouteChildren {
  ConsoleDevicesUserSessionIdRoute: typeof ConsoleDevicesUserSessionIdRoute
}

const ConsoleDevicesUserRouteChildren: ConsoleDevicesUserRouteChildren = {
  ConsoleDevicesUserSessionIdRoute: ConsoleDevicesUserSessionIdRoute,
}

const ConsoleDevicesUserRouteWithChildren =
  ConsoleDevicesUserRoute._addFileChildren(ConsoleDevicesUserRouteChildren)

interface ConsoleDevicesRouteChildren {
  ConsoleDevicesApplicationsRoute: typeof ConsoleDevicesApplicationsRouteWithChildren
  ConsoleDevicesLegacyRoute: typeof ConsoleDevicesLegacyRouteWithChildren
  ConsoleDevicesUserRoute: typeof ConsoleDevicesUserRouteWithChildren
  ConsoleDevicesIndexRoute: typeof ConsoleDevicesIndexRoute
}

const ConsoleDevicesRouteChildren: ConsoleDevicesRouteChildren = {
  ConsoleDevicesApplicationsRoute: ConsoleDevicesApplicationsRouteWithChildren,
  ConsoleDevicesLegacyRoute: ConsoleDevicesLegacyRouteWithChildren,
  ConsoleDevicesUserRoute: ConsoleDevicesUserRouteWithChildren,
  ConsoleDevicesIndexRoute: ConsoleDevicesIndexRoute,
}

const ConsoleDevicesRouteWithChildren = ConsoleDevicesRoute._addFileChildren(
  ConsoleDevicesRouteChildren,
)

interface ConsoleFederationKnownDomainsRouteChildren {
  ConsoleFederationKnownDomainsDestinationRoute: typeof ConsoleFederationKnownDomainsDestinationRoute
}

const ConsoleFederationKnownDomainsRouteChildren: ConsoleFederationKnownDomainsRouteChildren =
  {
    ConsoleFederationKnownDomainsDestinationRoute:
      ConsoleFederationKnownDomainsDestinationRoute,
  }

const ConsoleFederationKnownDomainsRouteWithChildren =
  ConsoleFederationKnownDomainsRoute._addFileChildren(
    ConsoleFederationKnownDomainsRouteChildren,
  )

interface ConsoleFederationRouteChildren {
  ConsoleFederationAllowedDomainsRoute: typeof ConsoleFederationAllowedDomainsRoute
  ConsoleFederationKnownDomainsRoute: typeof ConsoleFederationKnownDomainsRouteWithChildren
  ConsoleFederationIndexRoute: typeof ConsoleFederationIndexRoute
}

const ConsoleFederationRouteChildren: ConsoleFederationRouteChildren = {
  ConsoleFederationAllowedDomainsRoute: ConsoleFederationAllowedDomainsRoute,
  ConsoleFederationKnownDomainsRoute:
    ConsoleFederationKnownDomainsRouteWithChildren,
  ConsoleFederationIndexRoute: ConsoleFederationIndexRoute,
}

const ConsoleFederationRouteWithChildren =
  ConsoleFederationRoute._addFileChildren(ConsoleFederationRouteChildren)

interface ConsolePersonalTokensRouteChildren {
  ConsolePersonalTokensTokenIdRoute: typeof ConsolePersonalTokensTokenIdRoute
}

const ConsolePersonalTokensRouteChildren: ConsolePersonalTokensRouteChildren = {
  ConsolePersonalTokensTokenIdRoute: ConsolePersonalTokensTokenIdRoute,
}

const ConsolePersonalTokensRouteWithChildren =
  ConsolePersonalTokensRoute._addFileChildren(
    ConsolePersonalTokensRouteChildren,
  )

interface ConsoleRegistrationTokensRouteChildren {
  ConsoleRegistrationTokensTokenIdRoute: typeof ConsoleRegistrationTokensTokenIdRoute
}

const ConsoleRegistrationTokensRouteChildren: ConsoleRegistrationTokensRouteChildren =
  {
    ConsoleRegistrationTokensTokenIdRoute:
      ConsoleRegistrationTokensTokenIdRoute,
  }

const ConsoleRegistrationTokensRouteWithChildren =
  ConsoleRegistrationTokensRoute._addFileChildren(
    ConsoleRegistrationTokensRouteChildren,
  )

interface ConsoleRoomsRouteChildren {
  ConsoleRoomsRoomIdRoute: typeof ConsoleRoomsRoomIdRoute
}

const ConsoleRoomsRouteChildren: ConsoleRoomsRouteChildren = {
  ConsoleRoomsRoomIdRoute: ConsoleRoomsRoomIdRoute,
}

const ConsoleRoomsRouteWithChildren = ConsoleRoomsRoute._addFileChildren(
  ConsoleRoomsRouteChildren,
)

interface ConsoleUsersRouteChildren {
  ConsoleUsersUserIdRoute: typeof ConsoleUsersUserIdRoute
}

const ConsoleUsersRouteChildren: ConsoleUsersRouteChildren = {
  ConsoleUsersUserIdRoute: ConsoleUsersUserIdRoute,
}

const ConsoleUsersRouteWithChildren = ConsoleUsersRoute._addFileChildren(
  ConsoleUsersRouteChildren,
)

interface ConsoleRouteChildren {
  ConsoleAuditingRoute: typeof ConsoleAuditingRoute
  ConsoleDevicesRoute: typeof ConsoleDevicesRouteWithChildren
  ConsoleFederationRoute: typeof ConsoleFederationRouteWithChildren
  ConsolePersonalTokensRoute: typeof ConsolePersonalTokensRouteWithChildren
  ConsoleRegistrationTokensRoute: typeof ConsoleRegistrationTokensRouteWithChildren
  ConsoleRoomsRoute: typeof ConsoleRoomsRouteWithChildren
  ConsoleSupervisionRoute: typeof ConsoleSupervisionRoute
  ConsoleUsersRoute: typeof ConsoleUsersRouteWithChildren
  ConsoleVerificationLabelsRoute: typeof ConsoleVerificationLabelsRoute
  ConsoleIndexRoute: typeof ConsoleIndexRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleAuditingRoute: ConsoleAuditingRoute,
  ConsoleDevicesRoute: ConsoleDevicesRouteWithChildren,
  ConsoleFederationRoute: ConsoleFederationRouteWithChildren,
  ConsolePersonalTokensRoute: ConsolePersonalTokensRouteWithChildren,
  ConsoleRegistrationTokensRoute: ConsoleRegistrationTokensRouteWithChildren,
  ConsoleRoomsRoute: ConsoleRoomsRouteWithChildren,
  ConsoleSupervisionRoute: ConsoleSupervisionRoute,
  ConsoleUsersRoute: ConsoleUsersRouteWithChildren,
  ConsoleVerificationLabelsRoute: ConsoleVerificationLabelsRoute,
  ConsoleIndexRoute: ConsoleIndexRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ConsoleRoute: ConsoleRouteWithChildren,
  CallbackRoute: CallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
